function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

// Attach a click event listener to elements with the class 'yourButtonClass'
var elements = document.querySelectorAll('.footer-back .icon-scroll_to_top');
elements.forEach(function (element) {
  element.addEventListener('click', scrollToTop);
});
